import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzVday70 } from './pages'

type TIdToPageMapWoofzVday70 = Record<PageIdWoofzVday70, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_VDAY_70: TIdToPageMapWoofzVday70 = {
  [PageId.SUBSCRIPTIONS_VDAY_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_70/pages/subscriptions/SubscriptionVday70'
      ).then((m) => ({
        default: m.SubscriptionsVday70,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_70/pages/subscriptions/SubscriptionVday70'
      ),
  },
  [PageId.CHAT_UPSELL_VDAY_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_70/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_70/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_VDAY_70]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vday/woofz_vday_70/pages/upsell/Upsell').then(
        (m) => ({
          default: m.Upsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vday/woofz_vday_70/pages/upsell/Upsell'),
  },
  [PageIdWoofzVday70.DOWNLOAD_VDAY_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_70/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_70/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzVday70.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
